(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1698],{

/***/ 24931:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/careers",
      function () {
        return __webpack_require__(90535);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ core_Carousel; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./components/indicator/index.ts + 2 modules
var indicator = __webpack_require__(81049);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(10615);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/styles/carousel.css
var carousel = __webpack_require__(75472);
;// CONCATENATED MODULE: ./components/core/Carousel/Carousel.tsx






const imagesReducer = (images)=>{
    const imagesArr = [];
    if (images && images.length) {
        images.forEach((el)=>{
            const object = el;
            const key = Object.keys(el)[1];
            imagesArr.push(object[key]);
        });
        return imagesArr;
    }
    return;
};
const DEFAULT_CENTER_SLIDE_PERCENTAGE = 80;
const Carousel = (param)=>{
    let { images , imgClassName , children , centerMode , onSwipe , onChange , centerSlidePercentage , infinite =true  } = param;
    const imagesArr = imagesReducer(images);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(js/* Carousel */.lr, {
        onChange: onChange,
        onSwipeMove: onSwipe,
        showIndicators: true,
        showArrows: false,
        showStatus: false,
        swipeable: true,
        emulateTouch: true,
        preventMovementUntilSwipeScrollTolerance: true,
        swipeScrollTolerance: 50,
        infiniteLoop: infinite,
        showThumbs: false,
        autoPlay: false,
        centerMode: centerMode,
        centerSlidePercentage: centerSlidePercentage || DEFAULT_CENTER_SLIDE_PERCENTAGE,
        renderIndicator: (onClickHandler, isSelected, index, label)=>{
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(indicator/* default */.Z, {
                onClickHandler: onClickHandler,
                isSelected: isSelected,
                index: index,
                label: label
            });
        },
        children: (imagesArr === null || imagesArr === void 0 ? void 0 : imagesArr.map((item, index)=>{
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                ...(0,imageSerializer/* imageSerializer */.l)(item),
                className: imgClassName
            }, index);
        })) || children
    });
};

;// CONCATENATED MODULE: ./components/core/Carousel/index.ts

/* harmony default export */ var core_Carousel = (Carousel);


/***/ }),

/***/ 75987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ PlayIcon; },
/* harmony export */   "u": function() { return /* binding */ PlayIconWhite; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35944);

const PlayIcon = ()=>/*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                d: "M10 8L16 12L10 16V8Z",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
const PlayIconWhite = ()=>/*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
            d: "M5 3L19 12L5 21V3Z",
            stroke: "white",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });


/***/ }),

/***/ 81049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ indicator; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./common/consts/theme.ts
var theme = __webpack_require__(22004);
;// CONCATENATED MODULE: ./components/indicator/indicator.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n    "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const Item = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", {
    target: "eanor9r0"
})("position:relative;width:0.75rem;height:0.75rem;border:0.0625rem solid ", (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, ";border-radius:50%;background:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";overflow:hidden;margin:0 1.375rem 0 0;");
const RadioButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eanor9r1"
})("position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);overflow:hidden;width:0.5rem;height:0.5rem;border-radius:50%;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";", (param)=>{
    let { isSelected  } = param;
    return isSelected && (0,emotion_react_browser_esm/* css */.iv)(_templateObject(), theme/* THEME.colors.primary */.C.colors.primary);
}, ";");

;// CONCATENATED MODULE: ./components/indicator/Indicator.tsx


const Indicator = (param)=>{
    let { onClickHandler , isSelected , index , label  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Item, {
        onClick: onClickHandler,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RadioButton, {
            isSelected: isSelected
        })
    });
};


;// CONCATENATED MODULE: ./components/indicator/index.ts

/* harmony default export */ var indicator = (Indicator);


/***/ }),

/***/ 5650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sections_Hero; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./common/consts/theme.ts
var theme = __webpack_require__(22004);
// EXTERNAL MODULE: ./node_modules/emotion-rgba/dist/index.js
var dist = __webpack_require__(49484);
;// CONCATENATED MODULE: ./components/sections/Hero/hero.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-height: 9.25rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-height: 14rem;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-height: 22.5rem;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 1rem;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 1.25rem;\n    bottom: -2px;\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 1.875rem;\n    bottom: 0;\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 4.25rem;\n    line-height: 5.125rem;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 8rem;\n    line-height: 9.25rem;\n    margin-bottom: -1.6875rem;\n  "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 13rem;\n    line-height: 15.125rem;\n    margin-bottom: -2.75rem;\n  "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}





const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e8sppqh0"
})("position:relative;overflow:hidden;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";min-height:6rem;", mixins.mq.xSmall((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), ";", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), ";");
const Inner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e8sppqh1"
})(mixins/* defaultContainerSize */.sX, ";height:100%;display:flex;min-height:inherit;justify-content:flex-start;align-items:flex-end;");
const HeroBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("hr", {
    target: "e8sppqh2"
})("position:absolute;width:100vw;bottom:0;left:0;margin:0;border:none;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";height:0.5rem;", mixins.mq.xSmall((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())), ";", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject4())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject5())), ";");
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h1", {
    target: "e8sppqh3"
})("font-size:3.25rem;line-height:4rem;font-weight:400;letter-spacing:0.0375rem;background:linear-gradient(90deg,#584ca9 0%,#be4969 100%);background-clip:text;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";color:", (0,dist.rgba)(theme/* THEME.colors.core_white */.C.colors.core_white, 0), ";position:relative;user-select:none;margin:0 0 -0.6875rem 0;", mixins.mq.xSmall((0,emotion_react_browser_esm/* css */.iv)(_templateObject6())), ";", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject7())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject8())), ";");

;// CONCATENATED MODULE: ./components/sections/Hero/Hero.tsx



const Hero = (param)=>{
    let { title , lottieProps  } = param;
    const ref = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        __webpack_require__.e(/* import() */ 1807).then(__webpack_require__.bind(__webpack_require__, 70886));
        return ()=>{
            var _ref_current, _ref_current__lottie;
            (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : (_ref_current__lottie = _ref_current._lottie) === null || _ref_current__lottie === void 0 ? void 0 : _ref_current__lottie.destroy();
        };
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Inner, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                        children: title
                    }),
                    lottieProps && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("lottie-player", {
                        ref: ref,
                        autoplay: true,
                        mode: "normal",
                        class: "hero__lottie",
                        ...lottieProps
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroBlock, {})
        ]
    });
};

;// CONCATENATED MODULE: ./components/sections/Hero/index.ts

/* harmony default export */ var sections_Hero = (Hero);


/***/ }),

/***/ 50365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ Integration; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./common/consts/theme.ts
var theme = __webpack_require__(22004);
;// CONCATENATED MODULE: ./components/sections/Integration/integration.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: block;\n      height: 100%;\n      cursor: default;\n    "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      position: fixed;\n      align-items: center;\n      justify-content: center;\n      right: 0;\n      bottom: 0;\n      width: 100%;\n      height: 100%;\n      z-index: 100;\n      border-radius: 0;\n      background-color: ",
        ";\n      display: flex;\n      cursor: default;\n\n      > * {\n        border-radius: 0;\n      }\n    "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}



const Video = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("video", {
    target: "e4fvkr90"
})("border-radius:1rem;width:100%;height:auto;display:none;", (param)=>{
    let { isFullscreen  } = param;
    return isFullscreen && (0,emotion_react_browser_esm/* css */.iv)(_templateObject());
}, ";");
const VideoContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4fvkr91"
})("display:none;position:relative;border-radius:1rem;flex:0 0 100%;cursor:pointer;z-index:0;> *{border-radius:1rem;}", (param)=>{
    let { isFullscreen  } = param;
    return isFullscreen && (0,emotion_react_browser_esm/* css */.iv)(_templateObject1(), theme/* THEME.colors.core_black */.C.colors.core_black);
}, ";");
const VideoCloseButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4fvkr92"
})("top:60px;right:40px;position:fixed;width:2rem;height:2rem;cursor:pointer;transition:background-color 200ms ease-in-out;border-radius:0.0625rem;&:before{transform:rotate(-45deg);}&:after{transform:rotate(45deg);}&:before,&:after{content:'';position:absolute;height:3px;width:100%;top:50%;left:0;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";border-radius:0.0625rem;transition:background-color 200ms ease-in-out;box-shadow:0 0 4px 0.0625rem #1700594a;}&:hover{-webkit-background-clip:text;&:before,&:after{height:3px;background:linear-gradient(\n        88.48deg,#0f4ed7 0%,#684b9f 59.57%,#d2485c 98.61%\n      );}}");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/sections/Integration/Integration.tsx



const Integration = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { isFullscreen , handleClose  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VideoContainer, {
        isFullscreen: isFullscreen,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Video, {
                ref: ref,
                loop: true,
                controls: isFullscreen,
                isFullscreen: isFullscreen,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
                    src: "/videos/integracja.mp4",
                    type: "video/mp4"
                })
            }),
            isFullscreen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoCloseButton, {
                onClick: handleClose
            })
        ]
    });
});


/***/ }),

/***/ 65174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useMeetingVideo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const useMeetingVideo = ()=>{
    const [isFullscreen, setFullscreen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const videoRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const handlePlayVideo = ()=>{
        setFullscreen((prevState)=>!prevState);
    };
    const handleClose = ()=>{
        if (videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) {
            var _videoRef_current;
            (_videoRef_current = videoRef.current) === null || _videoRef_current === void 0 ? void 0 : _videoRef_current.pause();
        }
        setFullscreen(false);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const handleCloseVideo = (event)=>{
            if (event.code === "Escape" && (videoRef === null || videoRef === void 0 ? void 0 : videoRef.current)) {
                var _videoRef_current;
                setFullscreen(false);
                (_videoRef_current = videoRef.current) === null || _videoRef_current === void 0 ? void 0 : _videoRef_current.pause();
            }
        };
        document.addEventListener("keydown", handleCloseVideo);
        return ()=>{
            document.removeEventListener("keydown", handleCloseVideo);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) {
            videoRef.current.volume = 0.2;
        }
    }, []);
    return {
        handlePlayVideo,
        isFullscreen,
        handleClose,
        videoRef
    };
};


/***/ }),

/***/ 79794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ TitleAs; }
/* harmony export */ });
var TitleAs;
(function(TitleAs) {
    TitleAs["h1"] = "h1";
    TitleAs["h2"] = "h2";
    TitleAs["h3"] = "h3";
    TitleAs["h4"] = "h4";
    TitleAs["h5"] = "h5";
    TitleAs["h6"] = "h6";
})(TitleAs || (TitleAs = {}));


/***/ }),

/***/ 37645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(14588));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: (param)=>{
            let { error , isLoading , pastDelay  } = param;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 33644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14588:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _loadableContext = __webpack_require__(33644);
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = (0, _react).useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    let ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 90535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ careers; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/sections/Hero/index.ts + 2 modules
var Hero = __webpack_require__(5650);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
;// CONCATENATED MODULE: ./styles/pages/styled/career/careers.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 7.5rem;\n    padding-bottom: 8.75rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e84wb2m0"
})("background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";");
const JoinUsWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e84wb2m1"
})(mixins/* defaultContainerSize */.sX, ";margin-top:4rem;padding-bottom:4rem;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), ";");

// EXTERNAL MODULE: ./components/core/Typography/Typography.tsx
var Typography = __webpack_require__(44718);
;// CONCATENATED MODULE: ./components/sections/JobOpenings/jobOpenings.styles.tsx

function jobOpenings_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-bottom: 5.875rem;\n  "
    ]);
    jobOpenings_styles_templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 3rem;\n    line-height: 3.5rem;\n    margin-bottom: 2.5rem;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 5.625rem;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: row;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 3rem;\n    line-height: 3.5rem;\n    margin-bottom: 1rem;\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: auto;\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: auto;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n  "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 3.5rem;\n    padding-right: 3.5rem;\n  "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: block;\n  "
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 2rem;\n    padding-right: 2rem;\n    margin-bottom: 1.5rem;\n  "
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-bottom: 3.5rem;\n  "
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: auto;\n  "
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0.75rem 4rem;\n    max-width: 17.875rem;\n  "
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 0;\n  "
    ]);
    _templateObject14 = function() {
        return data;
    };
    return data;
}




const jobOpenings_styles_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "e18if5r00"
})("margin-top:5rem;");
const Inner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e18if5r01"
})("display:flex;flex-direction:column;", mixins/* defaultContainerSize */.sX, ";");
const InnerSecond = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Inner, {
    target: "e18if5r02"
})("padding-bottom:3.25rem;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(jobOpenings_styles_templateObject())), ";");
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h2", {
    target: "e18if5r03"
})(Typography/* Header2 */.zV, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";margin:0 0 2rem 0;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())), ";");
const JobsIntroduction = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e18if5r04"
})("max-width:35.4375rem;");
const IntroductionWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e18if5r05"
})("display:flex;flex-direction:column;justify-content:space-between;margin-bottom:2rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), ";", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())), ";");
const IntroductionTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h2", {
    target: "e18if5r06"
})("color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";letter-spacing:-0.0125rem;font-weight:400;font-size:2rem;line-height:2.5rem;max-width:27rem;margin:0 0 2rem 0;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject4())), ";");
const PlayVideoContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e18if5r07"
})("position:relative;padding:2px;background-image:linear-gradient(\n    100.54deg,#0e4ed7 0%,#7b4b93 48.44%,#f94743 100%\n  );display:inline-block;border-radius:5.75rem;margin-bottom:2rem;width:100%;", mixins.mq.small((0,emotion_react_browser_esm/* css */.iv)(_templateObject5())), ";");
const PlayVideoButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "e18if5r08"
})("border:none;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";font-weight:400;font-size:1.25rem;line-height:2rem;letter-spacing:0.0125rem;border-radius:5.75rem;padding:0.75rem 2rem;display:flex;align-items:center;justify-content:center;gap:0.625rem;width:100%;", mixins.mq.small((0,emotion_react_browser_esm/* css */.iv)(_templateObject6())), ";&:hover{background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";}");
const PrimaryColor = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e18if5r09"
})("color:", (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, ";");
const CarouselWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e18if5r010"
})("display:block;margin-bottom:4rem;padding-right:1rem;padding-left:1rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject7())), ";");
const TeamImageWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e18if5r011"
})("display:none;max-width:85.25rem;max-height:21.75rem;margin:0 auto 3.5rem;padding-left:1rem;padding-right:1rem;", mixins.mq.small((0,emotion_react_browser_esm/* css */.iv)(_templateObject8())), ";", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject9())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject10())), ";img{width:100%;height:100%;max-width:85.25rem;max-height:21.75rem;border-radius:0.5rem;}");
const TeamImagesWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e18if5r012"
})("display:none;flex-direction:row;justify-content:center;gap:1.28125rem;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject11())), ";");
const TeamImagesItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e18if5r013"
})("max-height:12.8125rem;max-width:15.375rem;img{height:12.8125rem !important;max-height:12.8125rem;max-width:100%;object-fit:cover;border-radius:0.5rem;}");
const Jobs = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e18if5r014"
})();
const ContactWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e18if5r015"
})("position:relative;z-index:2;");
const ContactText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e18if5r016"
})("font-size:1.5rem;line-height:2.25rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.nunito;
}, ";font-weight:700;margin:3rem 0 1.25rem;max-width:22.4375rem;");
const ActionButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "e18if5r017"
})("box-sizing:border-box;width:100%;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";font-size:1.25rem;line-height:2rem;border:none;border-radius:4rem;text-align:center;box-shadow:none;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";position:relative;padding:0.75rem 3rem;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, ";transition:background-color 300ms ease-in-out;text-decoration:none;display:inline-block;", mixins/* boxShadow */.Wn, ";", mixins.mq.small((0,emotion_react_browser_esm/* css */.iv)(_templateObject12())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject13())), ";&:before{content:'';z-index:-1;width:100%;height:100%;position:absolute;left:0;top:0;border-radius:4rem;background:linear-gradient(67.33deg,#0e4ed7 -19.99%,#f94743 98.54%);}&:focus{outline:none;}&:hover{background-color:transparent;}");
const JobDescription = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e18if5r018"
})(Typography/* ParagraphS */.fw, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";margin:0 0 2.5rem 0;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject14())), ";");
const JobBold = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("strong", {
    target: "e18if5r019"
})("font-weight:700;"); // ${mq.small(css`
 //   width: auto;
 // `)};
 //
 // ${mq.xLarge(css`
 //   padding: 0.75rem 4rem;
 //   max-width: 17.875rem;
 // `)};

;// CONCATENATED MODULE: ./utils/htmlSerializers/jobOpeningsHtmlSerializer.ts



const propsWithUniqueKey = (props, key)=>Object.assign(props || {}, {
        key
    });
// TODO: type of this function
const jobOpeningsHtmlSerializer = (type, element, content, children, key)=>{
    let props = {};
    switch(type){
        case prismic_reactjs.Elements.paragraph:
            props = {};
            return react.createElement(JobDescription, propsWithUniqueKey(props, key), children);
        case prismic_reactjs.Elements.strong:
            props = {};
            return react.createElement(JobBold, propsWithUniqueKey(props, key), children);
        default:
            return null;
    }
};

// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/images/PlayImages/PlayImages.tsx
var PlayImages = __webpack_require__(75987);
// EXTERNAL MODULE: ./models/enums/routes.ts
var routes = __webpack_require__(20365);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./common/consts/theme.ts
var theme = __webpack_require__(22004);
// EXTERNAL MODULE: ./node_modules/emotion-rgba/dist/index.js
var dist = __webpack_require__(49484);
;// CONCATENATED MODULE: ./components/sections/JobOpenings/JobItem/jobItem.styles.tsx

function jobItem_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-wrap: nowrap;\n    margin-bottom: 1.25rem;\n  "
    ]);
    jobItem_styles_templateObject = function() {
        return data;
    };
    return data;
}
function jobItem_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-right: 1rem;\n    font-size: 1.5rem;\n    flex: 0 0 auto;\n  "
    ]);
    jobItem_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function jobItem_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 400;\n    font-size: 1.5rem;\n    flex: 0 0 auto;\n  "
    ]);
    jobItem_styles_templateObject2 = function() {
        return data;
    };
    return data;
}







const JobItemWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e3j1zur0"
})("display:flex;justify-content:flex-start;align-items:flex-start;flex-wrap:wrap;margin-bottom:0.75rem;max-width:40rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(jobItem_styles_templateObject())), ";&:last-of-type{margin-bottom:0;}");
const Underline = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e3j1zur1"
})("border-bottom:0.125rem solid;border-image:linear-gradient(90deg,#394dbc 0%,#844b8d 100.75%);border-image-slice:1;border-top:0;border-left:0;border-right:0;");
const InnerUnderline = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e3j1zur2"
})("border-bottom:0.125rem solid ", (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, ";transition:border-bottom-color 200ms ease-in-out;");
const JobPosition = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((link_default()), {
    target: "e3j1zur3"
})("margin:0;", Typography/* ParagraphM */.Sl, ";font-weight:400;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";background:linear-gradient(\n    22.45deg,", theme/* THEME.colors.primary */.C.colors.primary, " 3.28%,", theme/* THEME.colors.accent */.C.colors.accent, " 102.02%\n  );background-clip:text;color:", (0,dist.rgba)(theme/* THEME.colors.primary */.C.colors.primary, 1), ";transition:color 200ms ease-in-out;text-decoration:none;&:hover{color:", (0,dist.rgba)(theme/* THEME.colors.primary */.C.colors.primary, 0), ";&:after{opacity:1;}", InnerUnderline, "{border-bottom-color:transparent;}}", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(jobItem_styles_templateObject1())), ";");
const JobSalary = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e3j1zur4"
})("margin:0;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";", Typography/* ParagraphS */.fw, ";flex:0 0 100%;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(jobItem_styles_templateObject2())), ";");

;// CONCATENATED MODULE: ./components/sections/JobOpenings/JobItem/JobItem.tsx




const JobItem = (param)=>{
    let { position , salary , seo_url  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(JobItemWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JobPosition, {
                href: "".concat(routes/* Routes.CareersId */.Z.CareersId).concat(prismic_reactjs.RichText.asText(seo_url)),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Underline, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InnerUnderline, {
                        children: prismic_reactjs.RichText.asText(position)
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JobSalary, {
                children: prismic_reactjs.RichText.asText(salary)
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/core/Carousel/index.ts + 1 modules
var Carousel = __webpack_require__(80087);
// EXTERNAL MODULE: ./components/sections/Integration/useMeetingVideo.ts
var useMeetingVideo = __webpack_require__(65174);
// EXTERNAL MODULE: ./components/sections/Integration/Integration.tsx + 1 modules
var Integration = __webpack_require__(50365);
;// CONCATENATED MODULE: ./components/sections/JobOpenings/JobOpenings.tsx











const JobOpenings = (param)=>{
    let { description , items , title , titleAs , noJobsOffers , noJobsOffersEmail , stickerActionLink , playVideoText , joinText , joinTextPrimary , sendCvText , sendCvButton , teamImage , teamImages , teamImagesMobile  } = param;
    const { handlePlayVideo , isFullscreen , handleClose , videoRef  } = (0,useMeetingVideo/* useMeetingVideo */.s)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(jobOpenings_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Inner, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(IntroductionWrapper, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(IntroductionTitle, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PrimaryColor, {
                                            children: [
                                                joinTextPrimary,
                                                " "
                                            ]
                                        }),
                                        joinText
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayVideoContainer, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PlayVideoButton, {
                                        onClick: handlePlayVideo,
                                        children: [
                                            playVideoText,
                                            " ",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayImages/* PlayIcon */.o, {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Integration/* Integration */.Y, {
                                    ref: videoRef,
                                    isFullscreen: isFullscreen,
                                    handleClose: handleClose
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JobsIntroduction, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(prismic_reactjs.RichText, {
                                render: description,
                                htmlSerializer: jobOpeningsHtmlSerializer
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Carousel/* default */.Z, {
                    images: teamImagesMobile
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TeamImageWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                    ...(0,imageSerializer/* imageSerializer */.l)(teamImage)
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TeamImagesWrapper, {
                children: teamImages.map((el, index)=>{
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TeamImagesItem, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                            ...(0,imageSerializer/* imageSerializer */.l)(el.team_images_item)
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InnerSecond, {
                children: [
                    items && items.length ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                                as: titleAs,
                                children: title
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Jobs, {
                                children: items.map((job, index)=>{
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JobItem, {
                                        ...job
                                    }, index);
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                        children: [
                            noJobsOffers,
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                href: stickerActionLink,
                                children: noJobsOffersEmail
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContactWrapper, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContactText, {
                                children: sendCvText
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActionButton, {
                                href: stickerActionLink,
                                children: sendCvButton
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/sections/JobOpenings/index.ts

/* harmony default export */ var sections_JobOpenings = (JobOpenings);

// EXTERNAL MODULE: ./models/enums/titleAs.ts
var titleAs = __webpack_require__(79794);
;// CONCATENATED MODULE: ./pages/careers/index.tsx








const DynamicJoinUs = dynamic_default()(()=>__webpack_require__.e(/* import() */ 4141).then(__webpack_require__.bind(__webpack_require__, 24141)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(24141)
            ]
    }
});
const DynamicOurHrTeam = dynamic_default()(()=>__webpack_require__.e(/* import() */ 6959).then(__webpack_require__.bind(__webpack_require__, 76959)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(76959)
            ]
    }
});
const DynamicWhyQodeca = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2245).then(__webpack_require__.bind(__webpack_require__, 32245)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(32245)
            ]
    }
});
const DynamicRecruitmentProcessCareers = dynamic_default()(()=>__webpack_require__.e(/* import() */ 7389).then(__webpack_require__.bind(__webpack_require__, 77389)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(77389)
            ]
    }
});
const DynamicWelcomeToOurTeam = dynamic_default()(()=>__webpack_require__.e(/* import() */ 7358).then(__webpack_require__.bind(__webpack_require__, 77358)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(77358)
            ]
    }
});
const DynamicGetToKnow = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(6121), __webpack_require__.e(6884)]).then(__webpack_require__.bind(__webpack_require__, 26884)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(26884)
            ]
    }
});
const Careers = (param)=>{
    let { data: { page  }  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero/* default */.Z, {
                title: "Careers",
                lottieProps: {
                    id: "career_hero_lottie",
                    src: "https://assets10.lottiefiles.com/packages/lf20_knwnvvne.json"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(sections_JobOpenings, {
                noJobsOffers: prismic_reactjs.RichText.asText(page.no_jobs_offers),
                noJobsOffersEmail: prismic_reactjs.RichText.asText(page.no_jobs_offers_email),
                title: prismic_reactjs.RichText.asText(page.openings_title),
                description: page.description,
                items: page.job_openings,
                titleAs: titleAs/* TitleAs.h3 */.P.h3,
                stickerActionLink: page.sticker_action_link.url || "",
                joinText: prismic_reactjs.RichText.asText(page.join_text_secondary),
                joinTextPrimary: prismic_reactjs.RichText.asText(page.join_text),
                playVideoText: prismic_reactjs.RichText.asText(page.play_video_button_text),
                sendCvText: prismic_reactjs.RichText.asText(page.send_us_cv),
                sendCvButton: prismic_reactjs.RichText.asText(page.send_us_cv_button),
                teamImage: page.team_image,
                teamImages: page.team_images,
                teamImagesMobile: page.team_images_mobile
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicWhyQodeca, {
                title: prismic_reactjs.RichText.asText(page.benefits_title1),
                benefits: page.benefits1,
                titleAs: titleAs/* TitleAs.h3 */.P.h3
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicOurHrTeam, {
                title: prismic_reactjs.RichText.asText(page.hr_team_title),
                team: page.hr_team,
                titleAs: titleAs/* TitleAs.h4 */.P.h4
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicGetToKnow, {
                title: prismic_reactjs.RichText.asText(page.meet_us),
                items: page.meet_us_stages,
                titleAs: titleAs/* TitleAs.h4 */.P.h4
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicRecruitmentProcessCareers, {
                title: prismic_reactjs.RichText.asText(page.recruitment_title),
                items: page.recruitment_process,
                titleAs: titleAs/* TitleAs.h5 */.P.h5
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicWelcomeToOurTeam, {
                titleAs: titleAs/* TitleAs.h5 */.P.h5,
                title: prismic_reactjs.RichText.asText(page.welcome_title),
                description: page.welcome_description,
                images: page.welcome_images,
                mainImage: page.welcome_main_image
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JoinUsWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicJoinUs, {
                    title: prismic_reactjs.RichText.asText(page.join_us.title),
                    description: prismic_reactjs.RichText.asText(page.join_us.description),
                    actionLabel: prismic_reactjs.RichText.asText(page.join_us.action_label),
                    actionLink: page.join_us.action_link.url || "",
                    titleAs: titleAs/* TitleAs.h6 */.P.h6,
                    joinUsText: prismic_reactjs.RichText.asText(page.join_us_careers_text),
                    joinUsPhone: prismic_reactjs.RichText.asText(page.join_us_careers_phone),
                    joinUsMail: prismic_reactjs.RichText.asText(page.join_us_careers_email),
                    joinUsImage: page.join_us_careers_image
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var careers = (Careers);


/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(37645)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4575,9774,2888,179], function() { return __webpack_exec__(24931); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);